module.exports = {"version":{"name":"","buildDate":"Thu May 24 2018 08:47:38 GMT+0200 (CEST)","version":"0.7.2"}}


//////////////////
// WEBPACK FOOTER
// ./assets/version.json
// module id = 1164
// module chunks = 0